var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6612_314063",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 12,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62169 4.68529C2.45194 4.51321 2.17486 4.51087 2.00277 4.68062C1.83127 4.85037 1.82952 5.12746 1.99927 5.29954L6.47344 9.83671C6.66652 10.0327 6.92494 10.1406 7.20027 10.1406C7.47502 10.1406 7.73402 10.0327 7.92711 9.83671L12.4007 5.29954C12.4841 5.21437 12.5261 5.10354 12.5261 4.99212C12.5261 4.87954 12.4824 4.76637 12.396 4.68062C12.2239 4.51087 11.9469 4.51321 11.7771 4.68529L7.30352 9.22187C7.26677 9.26037 7.22302 9.26562 7.20027 9.26562C7.17752 9.26562 7.13319 9.26037 7.09644 9.22187L2.62169 4.68529Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6612_314063)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.199219,
    y: 0.347656,
    width: 14,
    height: 14,
    fill: "#010101"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandDown);
export default __webpack_public_path__ + "static/media/expandDown.965618aaa2acbd414b39ad1eb81d01de.svg";
export { ForwardRef as ReactComponent };